module.exports = __webpack_public_path__ + "static/media/outline-calendar_today-24px.8dbfeb98.svg";